import { useState, useEffect } from 'react';

// sessionStorage-backed filter persistence.
// Filters survive in-session navigation (list <-> detail, edit, save, reload in same tab)
// and are cleared on: Clear Filters (handled by each page resetting to default),
// Company switch and Logout (clearAllPersistedFilters), and session end (tab close).
const PREFIX = 'erpfilters:';

/**
 * Drop-in replacement for useState that persists the value in sessionStorage.
 * @param {string} key  unique key for this filter set (e.g. "greyOrders.filters")
 * @param {*} defaultValue  default used when nothing is stored yet
 */
export function usePersistentFilters(key, defaultValue) {
  const storageKey = PREFIX + key;
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      return raw != null ? JSON.parse(raw) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      /* ignore quota / serialization errors */
    }
  }, [storageKey, value]);

  return [value, setValue];
}

/** Remove ALL persisted filters (used on company switch and logout). */
export function clearAllPersistedFilters() {
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(PREFIX)) keys.push(k);
    }
    keys.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}
